import { c as _c } from "react/compiler-runtime";
import { Datepicker, TextField } from '@petsmart-ui/sparky';
import moment, { type Moment } from 'moment';
import type { InputEvent } from 'react';
import type { SitePreviewData } from '@libs/common-next';
import { config } from './config';
import css from './date-picker.module.scss';
import { dateToAz, validateTime } from './utils';
type Props = {
  name: keyof SitePreviewData;
  value?: string | boolean;
  onChange: (key: keyof SitePreviewData, value?: string) => void;
};
export function DatePicker(t0) {
  const $ = _c(31);
  const {
    name,
    value,
    onChange
  } = t0;
  let date;
  let t1;
  if ($[0] !== value) {
    date = value ? moment(dateToAz(value as string)) : null;
    t1 = date?.format("HH:mm");
    $[0] = value;
    $[1] = date;
    $[2] = t1;
  } else {
    date = $[1];
    t1 = $[2];
  }
  const time = t1;
  let onDateChange;
  let onTimeChange;
  if ($[3] !== date || $[4] !== name || $[5] !== onChange) {
    onDateChange = newDate => {
      handleChange(newDate, "00:00");
    };
    onTimeChange = t2 => {
      const {
        currentTarget
      } = t2;
      if (validateTime(currentTarget.value)) {
        handleChange(date, currentTarget.value);
      }
    };
    const handleChange = (date_0, time_0) => {
      if (!date_0 || !time_0) {
        return;
      }
      const [hours, minutes] = time_0.split(":");
      date_0.set({
        hour: Number.parseInt(hours, 10),
        minute: Number.parseInt(minutes, 10)
      });
      onChange(name, date_0.format("YYYY-MM-DDTHH:mm:ss-07:00"));
    };
    $[3] = date;
    $[4] = name;
    $[5] = onChange;
    $[6] = onDateChange;
    $[7] = onTimeChange;
  } else {
    onDateChange = $[6];
    onTimeChange = $[7];
  }
  let t2;
  if ($[8] !== date || $[9] !== onDateChange) {
    t2 = <Datepicker date={date} label="Date" placeholder="" numberOfMonths={1} onDateChange={onDateChange} isOutsideRange={_temp} withFullScreenPortal={false} />;
    $[8] = date;
    $[9] = onDateChange;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== date || $[12] !== time) {
    t3 = time ?? date?.format("HH:mm");
    $[11] = date;
    $[12] = time;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== onTimeChange || $[15] !== t3) {
    t4 = <TextField label="Time" mask={config} defaultValue={t3} onInput={onTimeChange} />;
    $[14] = onTimeChange;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== t2 || $[18] !== t4) {
    t5 = <div className="site-preview-pickers">{t2}{t4}</div>;
    $[17] = t2;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  const t6 = date ? "visible" : "hidden";
  let t7;
  if ($[20] !== t6) {
    t7 = {
      visibility: t6
    };
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== name || $[23] !== onChange) {
    t8 = () => onChange(name, undefined);
    $[22] = name;
    $[23] = onChange;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t7 || $[26] !== t8) {
    t9 = <button type="button" className={css.reset} style={t7} onClick={t8} aria-label="Clear date">⊘</button>;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t5 || $[29] !== t9) {
    t10 = <div className={css.wrapper}>{t5}{t9}</div>;
    $[28] = t5;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  return t10;
}
function _temp() {
  return false;
}